import React, { useState, useEffect, useMemo } from 'react'

import { QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import InventorySnapshotsList from '@shared/inventory_snapshots/InventorySnapshotsList'
import InventorySnapshotConceptModal from '@shared/inventory_snapshots/InventorySnapshotConceptModal'

import { inventorySnapshotService } from '@services/admin/inventorySnapshotService'
import { inventoryTypeService } from '@services/admin/inventoryTypeService'

export default function AdminInventorySnapshotsList() {
  const { t } = useTranslation()
  const { addJob } = useAdminNotification()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  const [inventoryTypes, setInventoryTypes] = useState([])

  useEffect(() => {
    let cancelled = false
    inventoryTypeService.fetchList()
      .then(res => {
        if (cancelled) return
        if (res?.success && Array.isArray(res.data)) {
          setInventoryTypes(res.data)
        }
      })
      .catch(console.error)
    return () => { cancelled = true }
  }, [])

  const inventoryTypeOptions = useMemo(() => {
    return inventoryTypes
      .filter(it => it.name)
      .map(it => ({ label: it.name, value: it.name }))
  }, [inventoryTypes])

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['stocks', 'stocks.history']}
        guideButton={
          <Tooltip title={t('concepts.inventory_snapshots.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
      />
      <InventorySnapshotsList
        service={inventorySnapshotService}
        role="admin"
        showMerchantColumn={false}
        addJob={addJob}
        inventoryTypeOptions={inventoryTypeOptions}
      />
      <InventorySnapshotConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}
